import { COPY_TO_CLIPBOARD_BUTTON_TYPE_NAME } from '../../data/constants/buttonsNamesConstants';

export function getCopyToClipboardButton(idSuffix, attributes, additionalClasses = '') {
  return `<button clickable type='button' class="btn btn-white btn-xs ml-1 ${additionalClasses}" id='${COPY_TO_CLIPBOARD_BUTTON_TYPE_NAME}:${idSuffix}' ${attributes} click_action_type='${COPY_TO_CLIPBOARD_BUTTON_TYPE_NAME}'><i class="fa fa-copy" clickable_child></i></button>`;
}
